export const assetConfigMultiAtlasLiteral = {
  mapMoveCursor: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/vfx/atlus_mapmovecursor',
    json: 'vfx_cursor.json',
    clips: {
      ping: {
        prefix: 'move_01/vfx_',
        start: 246,
        end: 255,
        repeat: 0
      }
    }
  },
  vfx_charge02: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_charge02.json',
    clips: {
      charge: {
        prefix: 'charge_02/vfx_',
        start: 122,
        end: 138,
        repeat: -1
      }
    }
  },
  blitz_pellet: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/puffbot_projectile',
    json: 'puffbot_projectile.json',
    clips: {
      pellet: {
        prefix: 'projectile_',
        start: 1,
        end: 4,
        repeat: -1
      }
    }
  },
  effects: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/vfx',
    json: 'Vfx_data.json',
    clips: {
      beamUp: {
        prefix: 'beam_fx/beam_up/vfx_',
        start: 165,
        end: 181,
        repeat: -1
      },
      bite: {
        prefix: 'bite_fx/bite_01/vfx_',
        start: 27,
        end: 33,
        repeat: 0
      },
      cannonDashBeam: {
        prefix: 'CannonDash_fx/beam/vfx_',
        start: 109,
        end: 114,
        repeat: 0
      },
      cannonDashDust: {
        prefix: 'CannonDash_fx/dust/vfx_',
        start: 116,
        end: 120,
        repeat: 0
      },
      charge01: {
        prefix: 'charge_fx/charge_01/vfx_',
        start: 35,
        end: 41,
        repeat: -1
      },
      charge02: {
        prefix: 'charge_fx/charge_02/vfx_',
        start: 122,
        end: 138,
        repeat: -1
      },
      claw01: {
        prefix: 'claw_fx/claw_01/vfx_',
        start: 1,
        end: 5,
        repeat: 0
      },
      claw02: {
        prefix: 'claw_fx/claw_02/vfx_',
        start: 7,
        end: 11,
        repeat: 0
      },
      claw03: {
        prefix: 'claw_fx/claw_03/vfx_',
        start: 220,
        end: 226,
        repeat: 0
      },
      clawSlash: {
        prefix: 'claw_fx/slash_01/vfx_',
        start: 229,
        end: 235,
        repeat: 0
      },
      damage01: {
        prefix: 'damage_fx/damage_01/vfx_',
        start: 17,
        end: 19,
        repeat: 0
      },
      damage02: {
        prefix: 'damage_fx/damage_02/vfx_',
        start: 22,
        end: 25,
        repeat: 0
      },
      damage03: {
        prefix: 'damage_fx/damage_03/vfx_',
        start: 55,
        end: 59,
        repeat: 0
      },
      damage04: {
        prefix: 'damage_fx/damage_04/vfx_',
        start: 67,
        end: 73,
        repeat: 0
      },
      jet01: {
        prefix: 'jet_fx/jet_01/vfx_',
        start: 62,
        end: 65,
        repeat: 0
      },
      jet02: {
        prefix: 'jet_fx/jet_02/vfx_',
        start: 141,
        end: 150,
        repeat: 0
      },
      roarCast: {
        prefix: 'LionRoar_fx/cast/vfx_',
        start: 265,
        end: 272,
        repeat: 0
      },
      roar: {
        prefix: 'LionRoar_fx/roar_01/vfx_',
        start: 281,
        end: 286,
        repeat: 0
      },
      roarSplash: {
        prefix: 'LionRoar_fx/splash/vfx_',
        start: 275,
        end: 279,
        repeat: -1
      },
      markCast: {
        prefix: 'MarkAttack_fx/cast/vfx_',
        start: 88,
        end: 106,
        repeat: 0
      },
      markLanding: {
        prefix: 'MarkAttack_fx/mark/vfx_',
        start: 75,
        end: 86,
        repeat: 0
      },
      projectile01: {
        prefix: 'projectile_fx/projectile_01/vfx_',
        start: 13,
        end: 15,
        repeat: -1
      },
      projectile02: {
        prefix: 'projectile_fx/projectile_02/vfx_',
        start: 183,
        end: 202,
        repeat: -1
      },
      projectile03: {
        prefix: 'projectile_fx/projectile_03/vfx_',
        start: 204,
        end: 207,
        repeat: -1
      },
      projectile04: {
        prefix: 'projectile_fx/projectile_04/vfx_',
        start: 257,
        end: 263,
        repeat: -1
      },
      shoot01: {
        prefix: 'shoot_fx/shoot_01/vfx_',
        start: 43,
        end: 46,
        repeat: -1
      },
      shoot02: {
        prefix: 'shoot_fx/shoot_02/vfx_',
        start: 48,
        end: 53,
        repeat: -1
      },
      move: {
        prefix: 'UI_fx/move_01/vfx_',
        start: 246,
        end: 255,
        repeat: 0
      },
      touch: {
        prefix: 'UI_fx/touch_01/vfx_',
        start: 238,
        end: 243,
        repeat: 0
      }
    }
  },
  ui_active_scene: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/active-scene',
    json: 'ui_hud_3.json',
    clips: {}
  },
  ui_lobby_scene: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/lobby-scene/',
    json: 'lobbyui.json',
    clips: {}
  },
  or_ui_result_scene: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/results-scene/',
    json: 'or-results-screen.json',
    clips: {}
  },
  tutorial_scene: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/tutorials/',
    json: 'tutorials.json',
    clips: {}
  },
  tf_boundary_warn: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/tf/',
    json: 'boundaries_lights.json',
    clips: {}
  },
  tf_ui_result_scene: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/tf/',
    json: 'tf-results-screen.json',
    clips: {}
  },
  ui_health_bars: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/health-bars',
    json: 'TR_hp_bar.json',
    clips: {}
  },
  ui_mobile: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/hud/v2',
    json: 'atlas.json',
    clips: {}
  },
  ui_boost_modal: {
    path: './ui/boost_modal/atlas',
    json: 'atlas.json',
    clips: {}
  },
  bouncyBomb: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_fetchnswitch.json',
    clips: {
      Projectile: {
        prefix: 'projectile/dog_ball1_',
        start: 1,
        end: 13,
        repeat: -1
      },
      End: {
        prefix: 'end/dog_ball2_',
        start: 1,
        end: 15,
        repeat: 0
      },
      Loop: {
        prefix: 'loop/dog_ball_loop_',
        start: 1,
        end: 3,
        repeat: -1
      },
      Explosion: {
        prefix: 'explosion/dog_ball_explode_',
        start: 1,
        end: 9,
        repeat: 0
      }
    }
  },
  boneMine: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_burybone.json',
    clips: {
      plant: {
        prefix: 'plant/dog_mine_',
        start: 122,
        end: 153,
        repeat: 0
      },
      mine: {
        prefix: 'mine/dog_mine_',
        start: 155,
        end: 155,
        repeat: -1
      },
      activate: {
        prefix: 'activate/dog_mine_',
        start: 157,
        end: 160,
        repeat: 0
      },
      spin: {
        prefix: 'spin/dog_mine_',
        start: 162,
        end: 164,
        repeat: -1
      },
      explosion: {
        prefix: 'explosion/dog_mine_',
        start: 166,
        end: 185,
        repeat: 0
      }
    }
  },
  auraColumnsGold: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_positivefeedback.json',
    clips: {
      aura: {
        prefix: 'aura/dog_vfx_',
        start: 46,
        end: 67,
        repeat: -1
      },
      columns: {
        prefix: 'columns/dog_vfx_',
        start: 70,
        end: 85,
        repeat: -1
      },
      particles: {
        prefix: 'particles/dog_vfx_',
        start: 88,
        end: 102,
        repeat: -1
      },
      heal: {
        prefix: 'heal/dog_vfx_',
        start: 104,
        end: 120,
        repeat: 0
      }
    }
  },
  blueWaveBlast: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_supersonicbark.json',
    clips: {
      mainWaveHead: {
        prefix: 'main_wave/dog_bark_',
        start: 2,
        end: 11,
        repeat: 0
      },
      mainWaveTail: {
        prefix: 'main_wave_trail/dog_bark_',
        start: 15,
        end: 27,
        repeat: 0
      },
      sideWaveHead: {
        prefix: 'side_wave/dog_bark_',
        start: 30,
        end: 41,
        repeat: 0
      },
      sideWaveTail: {
        prefix: 'side_wave_trail/dog_bark_',
        start: 45,
        end: 53,
        repeat: 0
      }
    }
  },
  counterCowerSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_countercower.json',
    clips: {
      lightningBoltProjectileClip: {
        prefix: 'projectile/counter_cower',
        start: 1,
        end: 5,
        repeat: 0
      },
      fearAreaEffectClip: {
        prefix: 'area_ring/counter_cower',
        start: 7,
        end: 23,
        repeat: 0
      },
      energyTailSpawn: {
        prefix: 'energy_tail/counter_cower',
        start: 26,
        end: 30,
        repeat: 0
      },
      energyTailLoop: {
        prefix: 'energy_tail/counter_cower',
        start: 32,
        end: 39,
        repeat: -1
      },
      energyTailDisappear: {
        prefix: 'energy_tail/counter_cower',
        start: 41,
        end: 49,
        repeat: 0
      },
      hissing: {
        prefix: 'hissing_vfx/counter_cower',
        start: 52,
        end: 55,
        repeat: 0
      }
    }
  },
  hairballSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_hominghairball.json',
    clips: {
      explosionHairball: {
        prefix: 'explosion/homing_hairball',
        start: 23,
        end: 33,
        repeat: 0
      },
      projectileHairball: {
        prefix: 'projectile/homing_hairball',
        start: 1,
        end: 21,
        repeat: -1
      }
    }
  },
  megaSwatSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_megaswat.json',
    clips: {
      megaClawClip: {
        prefix: 'Mega_swat',
        start: 1,
        end: 6,
        repeat: 0
      }
    }
  },
  antPincerSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_minion_attack.json',
    clips: {
      antPincerClip: {
        prefix: 'minion_attack_vfx',
        start: 1,
        end: 8,
        repeat: 0
      }
    }
  },
  powerpounceSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_powerpounce.json',
    clips: {
      trailClip: {
        prefix: 'trail/power_pounce',
        start: 1,
        end: 5,
        repeat: 0
      },
      explosionClip: {
        prefix: 'explosion/power_pounce',
        start: 6,
        end: 15,
        repeat: 0
      },
      groundMarksClip: {
        prefix: 'cracks/power_pounce',
        start: 17,
        end: 31,
        repeat: 0
      }
    }
  },
  roadHogSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_roadhog.json',
    clips: {
      stompClip: {
        prefix: 'stomp/pig_vfx_',
        start: 310,
        end: 318,
        repeat: 0
      },
      sparksClip: {
        prefix: 'sparks/pig_vfx_',
        start: 321,
        end: 325,
        repeat: -1
      },
      windClip: {
        prefix: 'wind/pig_vfx_',
        start: 330,
        end: 344,
        repeat: -1
      }
    }
  },
  curlyCorkSkillA: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_curlycork_a.json',
    clips: {
      totemCastClip: {
        prefix: 'totem_cast/pig_vfx_',
        start: 80,
        end: 89,
        repeat: 0
      },
      totemSpawnClip: {
        prefix: 'totem_spawn/pig_vfx_',
        start: 91,
        end: 113,
        repeat: 0
      },
      totemLoopClip: {
        prefix: 'totem_loop/pig_vfx_',
        start: 115,
        end: 140,
        repeat: 0
      },
      spinStartClip: {
        prefix: 'spin_start/pig_vfx_',
        start: 142,
        end: 158,
        repeat: 0
      },
      spinLoopClip: {
        prefix: 'spin_loop/pig_vfx_',
        start: 160,
        end: 163,
        repeat: 0
      },
      spinJumpClip: {
        prefix: 'spin_jump/pig_vfx_',
        start: 166,
        end: 178,
        repeat: 0
      },
      spinEndClip: {
        prefix: 'spin_end/pig_vfx_',
        start: 180,
        end: 191,
        repeat: 0
      }
    }
  },
  curlyCorkSkillB: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_curlycork_b.json',
    clips: {
      pulse1BlueClip: {
        prefix: 'wave_1/pig_vfx_',
        start: 194,
        end: 230,
        repeat: 0
      },
      pulse2OrangeClip: {
        prefix: 'wave_2/pig_vfx_',
        start: 233,
        end: 269,
        repeat: 0
      },
      pulse3RedClip: {
        prefix: 'wave_3/pig_vfx_',
        start: 272,
        end: 308,
        repeat: 0
      }
    }
  },
  slobSludgeSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_slobsludge.json',
    clips: {
      spawn: {
        prefix: 'pig_vfx_',
        start: 2,
        end: 9,
        repeat: 0
      },
      loop: {
        prefix: 'pig_vfx_',
        start: 11,
        end: 33,
        repeat: -1
      },
      disappear: {
        prefix: 'pig_vfx_',
        start: 35,
        end: 41,
        repeat: 0
      }
    }
  },
  vacuumSneezeSkill: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_part_skill_swinesneeze.json',
    clips: {
      vacuumClip: {
        prefix: 'pig_vfx_',
        start: 44,
        end: 67,
        repeat: -1
      },
      sneezeClip: {
        prefix: 'pig_vfx_',
        start: 69,
        end: 77,
        repeat: 0
      }
    }
  },
  projRoleskillBounceBack: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_bounce_back.json',
    clips: {
      default: {
        prefix: 'bounceback_',
        start: 1,
        end: 18,
        repeat: -1
      }
    }
  },
  projRoleskillTriplethreat: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_triple_threat.json',
    clips: {
      default: {
        prefix: 'triple_threat_',
        start: 1,
        end: 9,
        repeat: -1
      }
    }
  },
  projRoleskillSupersoak: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_super_soak.json',
    clips: {
      default: {
        prefix: 'super_soak_',
        start: 1,
        end: 12,
        repeat: -1
      }
    }
  },
  aoeBurstSuperSoak: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_super_soak_aoe.json',
    clips: {
      default: {
        prefix: 'super_soak_aoe_',
        start: 1,
        end: 9,
        repeat: -1
      }
    }
  },
  projRoleskillDoubletime: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_double_time.json',
    clips: {
      default: {
        prefix: 'double_time_',
        start: 1,
        end: 10,
        repeat: -1
      }
    }
  },
  projRoleskillSelfDefense: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_self_defense.json',
    clips: {
      default: {
        prefix: 'self_defense_',
        start: 1,
        end: 13,
        repeat: -1
      }
    }
  },
  projRoleskillDefault: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_default.json',
    clips: {
      default: {
        prefix: 'default_',
        start: 1,
        end: 8,
        repeat: -1
      }
    }
  },
  projTower: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_tower_projectile.json',
    clips: {
      default: {
        prefix: 'tower_projectile_',
        start: 1,
        end: 9,
        repeat: -1
      }
    }
  },
  aoeBurst01: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_self_defense_aoe.json',
    clips: {
      default: {
        prefix: 'self_defense_aoe_',
        start: 1,
        end: 9,
        repeat: -1
      }
    }
  },
  laserBeam: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills',
    json: 'vfx_roleskill_default_b.json',
    clips: {
      default: {
        prefix: 'default_b_',
        start: 1,
        end: 6,
        repeat: 0
      }
    }
  },
  doors: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/doors',
    json: 'object_door_b.json',
    clips: {
      open: {
        prefix: 'door_obj',
        start: 3,
        end: 34,
        repeat: 0
      }
    },
    frames: {
      closed: 'door_obj0001',
      opened_red: 'door_obj0036',
      opened_yellow: 'door_obj0037',
      opened_teal_blue: 'door_obj0038',
      opened_electric_blue: 'door_obj0039',
      opened_no_lights: 'door_obj0040'
    }
  },
  vfxExplosion: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/vfx/explosion',
    json: 'vfx_explosion.json',
    clips: {
      default: {
        prefix: 'explosion_',
        start: 1,
        end: 10,
        repeat: 0
      }
    }
  },
  vfxHit: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/vfx/hit',
    json: 'vfx_hit.json',
    clips: {
      electricHitVfx1: {
        prefix: 'electric_a/vfx_hit',
        start: 1,
        end: 5,
        repeat: 0
      },
      electricHitVfx2: {
        prefix: 'electric_b/vfx_hit',
        start: 1,
        end: 7,
        repeat: 0
      },
      electricHitVfx3: {
        prefix: 'electric_c/vfx_hit',
        start: 1,
        end: 8,
        repeat: 0
      },
      mechanicHitVfx1: {
        prefix: 'mechanic_a/vfx_hit',
        start: 1,
        end: 7,
        repeat: 0
      },
      mechanicHitVfx2: {
        prefix: 'mechanic_b/vfx_hit',
        start: 1,
        end: 7,
        repeat: 0
      },
      mechanicHitVfx3: {
        prefix: 'mechanic_c/vfx_hit',
        start: 1,
        end: 7,
        repeat: 0
      },
      roleSkillHitVfx1: {
        prefix: 'raw_a/vfx_hit',
        start: 1,
        end: 7,
        repeat: 0
      },
      roleSkillHitVfx2: {
        prefix: 'raw_b/vfx_hit',
        start: 1,
        end: 9,
        repeat: 0
      },
      roleSkillHitVfx3: {
        prefix: 'raw_c/vfx_hit',
        start: 1,
        end: 6,
        repeat: 0
      }
    }
  },
  grassTile: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/terraforming/terrain',
    json: 'anim_grass.json',
    clips: {
      default: {
        prefix: 'grass_',
        start: 1,
        end: 36,
        repeat: 0
      }
    }
  },
  yellowArcProjectile: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/skills/swatterswing',
    json: 'vfx_part_skill_horse_projectile.json',
    clips: {
      default: {
        prefix: 'horse_vfx_',
        start: 1,
        end: 13,
        repeat: -1
      }
    }
  }
} as const;
